import { Component, Input, TemplateRef } from '@angular/core'

@Component({
  selector: 'hs-no-executions-available',
  styleUrls: ['no-executions-available.component.scss'],
  templateUrl: './no-executions-available.component.html',
})
export class NoExecutionsAvailableComponent {
  _isEmpty = true

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() content: TemplateRef<any> | null = null
  @Input() set isEmpty(value: boolean | null) {
    if (value == null) {
      return
    } else {
      this._isEmpty = value
    }
  }
}
